import { proxy, subscribe, useSnapshot } from 'valtio';
import { useCallback } from 'react';
export const CHAT_BOX_STATE_STORAGE_KEY = 'pt-chatbox-state';
const DefaultState = {
    flow: undefined,
    allowFirstMessage: false,
};
const getState = () => {
    var _a;
    return JSON.parse(((_a = globalThis.localStorage) === null || _a === void 0 ? void 0 : _a.getItem(CHAT_BOX_STATE_STORAGE_KEY)) || '{}');
};
const setState = (state) => localStorage.setItem(CHAT_BOX_STATE_STORAGE_KEY, JSON.stringify(state));
const ChatBoxStateStore = proxy(getState());
subscribe(ChatBoxStateStore, () => {
    setState(ChatBoxStateStore);
});
export const setChatBoxFlowState = (lineOfBusiness, flow) => {
    var _a;
    ChatBoxStateStore[lineOfBusiness] = Object.assign(Object.assign({}, ((_a = ChatBoxStateStore[lineOfBusiness]) !== null && _a !== void 0 ? _a : DefaultState)), { flow });
};
export const setAllowFirstMessageState = (lineOfBusiness, allowFirstMessage) => {
    var _a;
    ChatBoxStateStore[lineOfBusiness] = Object.assign(Object.assign({}, ((_a = ChatBoxStateStore[lineOfBusiness]) !== null && _a !== void 0 ? _a : DefaultState)), { allowFirstMessage });
};
export const useChatBoxStateStore = (lineOfBusiness) => {
    var _a;
    const snapshot = useSnapshot(ChatBoxStateStore);
    const setChatBoxFlow = useCallback((flow) => setChatBoxFlowState(lineOfBusiness, flow), [lineOfBusiness]);
    const setAllowFirstMessage = useCallback((allowFirstMessage) => setAllowFirstMessageState(lineOfBusiness, allowFirstMessage), [lineOfBusiness]);
    return Object.assign(Object.assign({}, ((_a = snapshot[lineOfBusiness]) !== null && _a !== void 0 ? _a : DefaultState)), { setChatBoxFlow,
        setAllowFirstMessage });
};
//# sourceMappingURL=chatBoxStateStore.js.map